import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Modal, Button, Card, CardBody} from "reactstrap";
import PropTypes from "prop-types";
import {groupPermissionsList, groupPermissionsNew, groupPermissionsEdit} from "../../../store/groups/permissions/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import paginationFactory, {PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";
import SelectModal from "../../../components/Common/SelectModal";
import {apiGetSectionsList, apiGetSegmentsList} from "../../../api/calls/groupPermissions"
import {get, patch} from "../../../api/api";
import {format} from "react-string-format";
import * as url from "../../../api/url";

class GroupPermissionsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      permissionsData: [],
      loading: false,
      error: "",
      permissionData: null,
      newModal: false,
      deleteModal: false,
      sectionsModal: false,
      segmentsModal: false,
    }
    this.refresh = this.refresh.bind(this)
    this.togNew = this.togNew.bind(this)
    this.togDelete = this.togDelete.bind(this)
    this.togSections = this.togSections.bind(this)
    this.togSegments = this.togSegments.bind(this)
    this.apiGetSectionsSelected = this.apiGetSectionsSelected.bind(this)
    this.apiGetSegmentsSelected = this.apiGetSegmentsSelected.bind(this)
    this.apiPatchSectionsUpdate = this.apiPatchSectionsUpdate.bind(this)
    this.apiPatchSegmentsUpdate = this.apiPatchSegmentsUpdate.bind(this)
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    this.props.onGroupPermissionsList({history: this.props.history, groupId: this.props.groupData.id})
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        permissionsData: this.props.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      permissionData: data,
      newModal: !prevState.newModal,
    }))
  }

  togDelete(data = null) {
    this.setState(prevState => ({
      permissionData: data,
      deleteModal: !prevState.deleteModal,
    }))
  }

  togSections(data = null) {
    this.setState(prevState => ({
      selectData: data,
      sectionsModal: !prevState.sectionsModal,
    }))
  }

  togSegments(data = null) {
    this.setState(prevState => ({
      selectData: data,
      segmentsModal: !prevState.segmentsModal,
    }))
  }

  apiGetSectionsSelected = data => {
    return get(format(url.API_GROUP_PERMISSIONS_DETAIL, this.props.groupData.id, this.state.selectData.id) + "sections/", this.props.history)
  }

  apiPatchSectionsUpdate = data => {
    return patch(format(url.API_GROUP_PERMISSIONS_DETAIL, this.props.groupData.id, this.state.selectData.id), this.props.history, {sections: data.selectedRows})
  }

  apiGetSegmentsSelected = data => {
    return get(format(url.API_GROUP_PERMISSIONS_DETAIL, this.props.groupData.id, this.state.selectData.id) + "segments/", this.props.history)
  }

  apiPatchSegmentsUpdate = data => {
    return patch(format(url.API_GROUP_PERMISSIONS_DETAIL, this.props.groupData.id, this.state.selectData.id), this.props.history, {segments: data.selectedRows})
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        {(row.type.id === 100 || row.type.id === 101) && (<Button color="info" className="me-2 mb-2" onClick={() => this.togSections({id: row.id})}>Sections</Button>)}
        {(row.type.id === 200 || row.type.id === 201) && (<Button color="info" className="me-2 mb-2" onClick={() => this.togSegments({id: row.id})}>Segments</Button>)}
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, type: {value: row.type.id, label: row.type.name}}, "edit")}>Edit</Button>
        <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, type: row.type})}>Delete</Button>
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "type.name", text: "Type", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.permissionsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.type.name.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose} size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Permissions
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={this.state.permissionsData}
            >
              {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                keyField="id"
                columns={columns}
                data={this.state.permissionsData}
                search={{onColumnMatch}}
              >
                {toolkitProps => (<React.Fragment>
                  <Row className="mb-2">
                    <Col md="8">
                      <div>
                        <Button color="primary" onClick={() => this.togNew({}, "new")}>
                          New
                        </Button>
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block float-end">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                          <i className="bx bx-search-alt search-icon"/>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps}/>
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps}/>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>)}
              </ToolkitProvider>)}
            </PaginationProvider>
            {this.state.loading && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {this.state.error.length > 0 && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {this.state.error}
              </Alert>
            </div>)}
          </CardBody>
        </Card>
      </Modal>
      {this.state.newModal &&
        <NewModal action={this.state.action}
                  togModal={this.togNew}
                  refreshParent={this.refresh}
                  permissionData={this.state.permissionData}
                  groupId={this.props.groupData.id}
                  history={this.props.history}/>}
      {this.state.deleteModal &&
        <DeleteModal togModal={this.togDelete}
                     refreshParent={this.refresh}
                     permissionData={this.state.permissionData}
                     groupId={this.props.groupData.id}
                     history={this.props.history}/>}
      {this.state.sectionsModal &&
        <SelectModal togModal={this.togSections}
                     refreshParent={this.refresh}
                     title="Select sections"
                     apiList={apiGetSectionsList}
                     apiSelected={this.apiGetSectionsSelected}
                     apiUpdate={this.apiPatchSectionsUpdate}
                     selectData={this.state.selectData}
                     history={this.props.history}/>}
      {this.state.segmentsModal &&
        <SelectModal togModal={this.togSegments}
                     refreshParent={this.refresh}
                     title="Select segments"
                     apiList={apiGetSegmentsList}
                     apiSelected={this.apiGetSegmentsSelected}
                     apiUpdate={this.apiPatchSegmentsUpdate}
                     selectData={this.state.selectData}
                     history={this.props.history}/>}
    </React.Fragment>)
  }
}

GroupPermissionsModal.propTypes = {
  response: PropTypes.any,
};

const mapStateToProps = ({GroupPermissions}) => ({
  response: GroupPermissions.responseList,
  loading: GroupPermissions.loadingList,
  error: GroupPermissions.errorList,
});

const mapDispatchToProps = dispatch => ({
  onGroupPermissionsList: data => dispatch(groupPermissionsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GroupPermissionsModal));